import { Component, OnInit, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Constant, BaseComponent} from '../../../../../../../infrastructure/common/index';
import {
  TicketService,
} from '../../../../../../../infrastructure/services/transaction/op/outbound/ticket/index';

@Component({
  selector: 'app-ticket-confirmation',
  templateUrl: './ticket-confirmation.component.html',
  styleUrls: ['./ticket-confirmation.component.css']
})
export class TicketConfirmationComponent extends BaseComponent implements OnInit {
  @Input() BookingNoTxt: string;
  isLoading = false;

  constructor(private ticketService: TicketService) { 
    super();
  }

  ngOnInit() {
  }

  preview(form: NgForm) {
    let self = this;
    this.isLoading = true;

    this.ticketService.generateTicket(self.token.DefaultOwnerCode, self.BookingNoTxt).subscribe(
      (data) => {
        self.isLoading = false;
        form.resetForm();
        var fileURL = URL.createObjectURL(data);
        window.open(fileURL);
      },
      error => {
        // alert(JSON.stringify(error));
        // alert(error);
        self.isLoading = false;
        self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
      }
    );
  }

  showAlert(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
    alert(title + ': (' + messageNumber + ') ' + message + '--' + (additionalInfo ? ' -- ' + additionalInfo : ''))
  }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/outbound/ticket/ticket-confirmation/ticket-confirmation.component.ts